import {
  ExclamationCircleFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { columns } from './columns'
import { EditDetailModal } from './editDetailModal'
import { RootDispatch } from '../../app/store'
import { ThemeContext } from '../../theme/ThemeContext'
import { EditableList } from '../../compnents/list/EditableList'
import {
  getReservationChannelList,
  getReservationChannelUpload,
} from './reservationChannelSlice'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'

export interface ReservationChannelRef {
  refresh?: () => void
  tabKey?: any
}

interface ReservationChannelProps {
  tabKey?: any
}
const ReservationChannels = (
  { tabKey }: ReservationChannelProps,
  ref: React.Ref<ReservationChannelRef>
): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [isEditRemarkVisible, setIsEditRemarkVisible] = useState(false)

  const [id, setId] = useState<string>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState({ items: [], total: 0 })

  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getReservationChannelList({
        ...params,
        current: params.current,
        size: params.size,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    getPage()
  }, [params])

  return (
    <TabBar destroyInactiveTabPane style={{ margin: '10px 20px' }}>
      <TabPane key='0' tab='合作机构'>
        <Col
          style={{
            height: 'calc(100% - 30px)',
            overflow: 'hidden',
            position: 'relative',
            margin: '10px 0px 10px 0px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Col
            style={{
              flex: 1,
              backgroundColor: theme.pn,
              borderRadius: 10,
              padding: '10px 15px 0 15px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Form
              form={form}
              autoComplete='off'
              onFinish={(values) => {
                setParams({ ...params, ...values, current: 1 })
              }}
            >
              <Row
                align='middle'
                justify='space-between'
                style={{ marginTop: 10, marginBottom: 20 }}
              >
                <Space>
                  <Form.Item name='name' noStyle>
                    <Input
                      placeholder='机构名称'
                      style={{ width: 200 }}
                      prefix={<SearchOutlined color={theme.tc3} />}
                      allowClear
                      onChange={form.submit}
                    />
                  </Form.Item>
                  <Form.Item name='status' noStyle>
                    <Select
                      placeholder='状态'
                      onChange={form.submit}
                      allowClear
                      style={{ width: 140 }}
                    >
                      <Select.Option value={0}>正常</Select.Option>
                      <Select.Option value={1}>已解绑</Select.Option>
                    </Select>
                  </Form.Item>
                  <Button type='primary' onClick={form.submit}>
                    查询
                  </Button>
                </Space>
                <Space>
                  <Button
                    type='primary'
                    onClick={() => {
                      setIsEditRemarkVisible(true)
                    }}
                  >
                    新增合作机构
                  </Button>
                </Space>
              </Row>
            </Form>
            <EditableList
              page={{
                items: page.items,
                current: params.current,
                size: params.size,
                total: page.total,
              }}
              loading={pageLoading}
              columns={columns((action: any, v: any, e: any) => {
                console.log(v, '33333333333')

                switch (action) {
                  case 'removeBinding':
                    Modal.confirm({
                      centered: true,
                      title: '',
                      content: <div>是否确认解除绑定？</div>,
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(
                          getReservationChannelUpload({
                            id: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((v) => {
                            notification.success({
                              message: '操作成功',
                              duration: 3,
                            })
                            getPage()
                          })
                      },
                    })
                    break
                  case 'resctBinding':
                    Modal.confirm({
                      centered: true,
                      title: '',
                      content: <div>是否确认重新绑定？</div>,
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(
                          getReservationChannelUpload({
                            id: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((v) => {
                            notification.success({
                              message: '操作成功',
                              duration: 3,
                            })
                            getPage()
                          })
                      },
                    })
                    break
                }
              }, params.size * (params.current - 1))}
              onChangePage={(current, size) => {
                console.log(params, 'change')
                setParams({ ...params, current, size: size || 10 })
              }}
            />
          </Col>
          <EditDetailModal
            id={id}
            visible={isEditRemarkVisible}
            onCancel={() => {
              setIsEditRemarkVisible(false)
              setId('')
              getPage()
            }}
            onOk={() => {
              setIsEditRemarkVisible(false)
              setId('')
              getPage()
            }}
          />
        </Col>
      </TabPane>
    </TabBar>
  )
}

export const ReservationChannelList = forwardRef(ReservationChannels)
